import { MaybeUndef } from 'types/UtilityTypes';

export interface LTLCustomerData {
  customerId: string;
  customerName: string;
  externalId?: string;
}

export interface LTLCustomerStaffData {
  ownerId: number;
  ownerName: string;
  tmsIntegrationId: number;
}

export function roundToTwoDecimals(n: number): number {
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
}

export function normalizeNumericValue(
  value: MaybeUndef<number | string>,
  defaultValue: number = 0
): number {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }

  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(parsed)) {
    return defaultValue;
  }

  return parsed;
}
